import restCrudReducer from '../../../np-crud/store/restCrudReducer';

const [crudInitialState, crudReducer] = restCrudReducer({
    pluginName: 'PRODUCT',
    entityName: 'HEADPHONE_PRODUCT',
});

const initialState = {
    ...crudInitialState,
    deletedHeadphoneProduct: {},
    deleting: false,
    saving: false,
    generate: false,
    gallery: false

};
const reducer = (state = initialState, action) => {
    // Handle CRUD actions
    const newState = crudReducer(state, action);
    // If CRUD reducer handled the action
    if (newState !== null) {
        return newState;
    }
    // Handle other actions
    switch (action.type) {
        case 'GALLERY_OPEN_HEADPHONE':
            return { ...state, gallery: !state.gallery };
        case 'START_GENERATE':
            return { ...state, generate: false };
        case 'FINISH_GENERATE':
            return { ...state, generate: true };
        case 'HANDLE_HEADPHONE_PRODUCT':
            return { ...initialState, loaded: action.productHeadphone };
        case 'CLEAN_STATE':
            return initialState;
        case 'CORE|LOGOUT_SUCCESS':
        case 'CORE|CORE_SET_ACTIVE_CUSTOMER_SUCCESS':
            return initialState;
        default:
            return state;
    }
};

export default reducer;
